export var MoreActions = "More actions";
export var MoreTooltip = "More...";
export var RemovePillLabel = "Remove";
export var SortedAscending = "Sorted ascending";
export var SortedDescending = "Sorted descending";
export var Started = "Started {0}";
